/* eslint-disable */

import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";
import Draggable from "gsap/Draggable";
import Flickity from "flickity";
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
import AirDatepicker from "air-datepicker";
import localeEn from "air-datepicker/locale/en";
import Swiper from "swiper";
import { Navigation, Autoplay, Mousewheel } from "swiper/modules";
import EffectCarousel from "./effect-carousel.esm";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, Draggable);

const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    /** MENU MOBILE */
    const togglesMenu = document.querySelectorAll(".toggle-menu");
    if (togglesMenu) {
      togglesMenu.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
          if (!HTML.classList.contains("open-menu"))
            window.dispatchEvent(new Event("close-all-links"));
        });
      });
    }

    /** SEARCH */
    const triggerSearch = document.querySelectorAll(".trigger-search");
    if (triggerSearch) {
      const input = document.querySelector(".block-search input");

      triggerSearch.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          HTML.classList.toggle("open-search");

          if (HTML.classList.contains("open-search") && input) {
            input.focus();
          }
        });
      });

      document.body.addEventListener("click", (e) => {
        if (
          HTML.classList.contains("open-search") &&
          !e.target.classList.contains("block-search") &&
          !e.target.closest(".block-search")
        ) {
          HTML.classList.remove("open-search");
        }
      });

      const menuLinks = document.querySelectorAll(".main-nav .menu li");
      if (menuLinks && menuLinks.length > 0) {
        menuLinks.forEach((li) => {
          li.addEventListener("mouseenter", () => {
            HTML.classList.remove("open-search");
          });
        });
      }
    }

    this.menu();
    this.sticky();
    this.liveSearch();
    this.tabs();
    this.marqueeCarousel();
    this.datepicker();
    this.clamp();
    this.filters();
    this.accordion();
    this.aside();
    this.ticketsProtected();
    this.map();
    this.marquee();
    this.slider();
    this.pinSlider();
    this.sliderTestimonial();
    this.carousel();
    this.sliderCover();
    this.anchor();
    this.inViewport();
  }

  anchor() {
    function goto(target, hash) {

      HTML.classList.remove("open-menu");
      window.dispatchEvent(new Event("close-all-links"));

      let offset = document.querySelector(".main-header").offsetHeight +
            (window.innerWidth > 768 ? 100 : 60);

      const pinSlider = target.closest('.pin-slider');
      if( pinSlider ) {
        const items = [...pinSlider.querySelectorAll(".content-item")];
        const element = target.closest('.content-item');

        const index = items.indexOf(element);
        offset -= window.innerHeight * index;
      }

      gsap.to(window, {
        scrollTo: {
          y: target,
          offsetY:offset
        },
        duration: 0.5,
        ease: "power2.inOut",
      });

      // met à jour l'URL
      history.pushState(null, "", hash);
    }

    /** ANCHOR */
    const anchorLinks = document.querySelectorAll('a[href*="#"]');
    if (anchorLinks) {
      anchorLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
          const url = new URL(this.href);

          // Vérifie qu'on est sur la même page
          const samePage =
            url.pathname === window.location.pathname &&
            url.hostname === window.location.hostname;

          if (!samePage || !url.hash) return;

          const target = document.querySelector(url.hash);

          if (!target) return;

          e.preventDefault();

          goto(target, url.hash);
        });
      });
    }

    const hash = window.location.hash;

    // Empêche le scroll auto du navigateur
    if (hash) {
      history.scrollRestoration = 'manual';

      // retire temporairement le hash de l'URL
      history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search
      ); 
      requestAnimationFrame(() => {

        const target = document.querySelector(hash);

        if (target) {
          setTimeout(() => {
            goto(target, hash);
          }, 200);
        }
      })
    }
  }

  menu() {
    // FIRST LEVEL
    const menusChildren = document.querySelectorAll(
      ".main-nav .menu > li.menu-item-has-children > a"
    );

    if (menusChildren) {
      menusChildren.forEach((lvl1) => {
        const parent = lvl1.closest("li.menu-item-has-children");
        let timer = 0;

        function closeLvl2(current = false) {
          const submenuLvl2 = parent.querySelectorAll(".is-open .sub-menu");

          if (submenuLvl2) {
            submenuLvl2.forEach((sub) => {
              if (current && current == sub) return;

              const parentLvl2 = sub.closest("li.is-open");
              parentLvl2.classList.remove("is-open");
              gsap.to(sub, {
                duration: 0.3,
                ease: "circ.inOut",
                height: 0,
              });
            });
          }
        }

        function openSubmenu() {
          if (parent.classList.contains("hover")) {
            window.dispatchEvent(new Event("close-all-links"));
          } else {
            parent.classList.add("hover");
            gsap.to(lvl1.nextElementSibling, {
              duration: 0.3,
              ease: "circ.inOut",
              height: lvl1.nextElementSibling.scrollHeight,
              onComplete: () => {
                parent.classList.add("showed");
              },
            });
          }
        }

        lvl1.addEventListener("click", (e) => {
          if ("ontouchstart" in window || navigator.maxTouchPoints > 0) {
            e.preventDefault();
            e.stopPropagation();
          }

          // openSubmenu();
        });
        parent.addEventListener("mouseenter", () => {
          clearTimeout(timer);

          openSubmenu();
        });
        parent.addEventListener("mouseleave", () => {
          if (window.innerWidth > 800) {
            timer = setTimeout(() => {
              parent.classList.remove("hover");
              closeLvl2();
            }, 200);
          }
        });

        window.addEventListener("close-all-links", () => {
          parent.classList.remove("hover");
          closeLvl2();
          gsap.fromTo(
            lvl1.nextElementSibling,
            {
              height: lvl1.nextElementSibling.scrollHeight,
            },
            {
              duration: 0.3,
              ease: "circ.inOut",
              height: 0,
              onStart: () => {
                parent.classList.remove("showed");
              },
            }
          );
        });

        // SECOND LEVEL
        const secondsLvl = lvl1.nextElementSibling.querySelectorAll(
          "li.menu-item-has-children > a"
        );
        if (secondsLvl) {
          secondsLvl.forEach((lvl2) => {
            lvl2.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();

              const parentLvl2 = lvl2.closest("li");
              const submenuLvl2 = parentLvl2.querySelector(".sub-menu");

              if (submenuLvl2) {
                if (parentLvl2.classList.contains("is-open")) {
                  closeLvl2();
                } else {
                  closeLvl2(submenuLvl2);

                  parentLvl2.classList.add("is-open");
                  gsap.to(submenuLvl2, {
                    duration: 0.3,
                    ease: "circ.inOut",
                    height: submenuLvl2.scrollHeight,
                  });
                }
              }
            });
          });
        }
      });
    }

    /** SUB MENU MOBILE */
    const submenuLinks = document.querySelectorAll(
      ".main-nav .menu-item-has-children"
    );
    if (submenuLinks) {
      submenuLinks.forEach((link) => {
        const sub = link.querySelector(".sub-menu");

        // link.querySelector("a").addEventListener("click", (e) => {
        //   if (window.innerWidth < 1000) {
        //     e.preventDefault();
        //     e.stopPropagation();
        //     sub.classList.add("show");
        //     HTML.classList.add("show-submenu");
        //   }
        // });

        const back = link.querySelector(".back");
        if (back) {
          back.addEventListener("click", (e) => {
            e.preventDefault();
            sub.classList.remove("show");
            HTML.classList.remove("show-submenu");
          });
        }
      });
    }
  }

  sliderCover() {
    const elts = document.querySelectorAll(".cover-slider");
    const autoplayDuration = 5;

    if (elts) {
      elts.forEach((el) => {
        const sw = new Swiper(el, {
          effect: "carousel",
          grabCursor: true,
          loop: true,
          slidesPerView: "auto",
          carouselEffect: {
            // opacity change per side slide
            opacityStep: 0.8,
            // scale change per side slide
            scaleStep: 0.3,
            sideSlides: 3,
          } /* ,
          mousewheel: {
            forceToAxis: true,
            sensitivity: 0.1,
            thresholdDelta: 5, // équivalent de ton threshold
            thresholdTime: 50, // évite les spam scroll
            releaseOnEdges: true, // laisse scroll page aux extrémités
          } */,
          modules: [EffectCarousel, Navigation, Autoplay, Mousewheel],
          navigation: {
            nextEl: ".slider-next",
            prevEl: ".slider-prev",
          },
          autoplay: {
            delay: autoplayDuration * 1000,
          },
          init: false,
        });

        const pager = el.querySelectorAll(".slider-pager a");
        if (pager) {
          pager.forEach((link, i) => {
            link.addEventListener("click", (e) => {
              e.preventDefault();
              // console.log(Math.round(sw.realIndex / 3));
              sw.slideTo(i);
            });
          });

          let current = 0;

          function gotoProgress(index) {
            gsap.fromTo(
              pager[index].querySelector(".progress"),
              {
                x: "-100%",
              },
              {
                x: "0%",
                duration: autoplayDuration,
                ease: "none",
              }
            );

            current = index;
          }

          sw.on("init", function () {
            gotoProgress(0);
          });
          sw.on("slideChangeTransitionStart", function () {
            if (current >= 0) {
              gsap.killTweensOf("*");
              gsap.to(pager[current].querySelector(".progress"), {
                x: "100%",
                ease: "circ.inOut",
                duration: 0.2,
              });
            }
          });
          sw.on("slideChangeTransitionEnd", function () {
            gotoProgress(this.realIndex % pager.length);
          });

          sw.init();
        }
      });
    }
  }

  datepicker() {
    const elts = document.querySelectorAll(".datepicker");

    if (elts) {
      elts.forEach((el) => {
        const inputStart = el.dataset.dateStart
          ? el
              .closest(".filter-item")
              .querySelector(`[name="${el.dataset.dateStart}"]`)
          : false;
        const inputEnd = el.dataset.dateEnd
          ? el
              .closest(".filter-item")
              .querySelector(`[name="${el.dataset.dateEnd}"]`)
          : false;

        const ad = new AirDatepicker(el, {
          inline: true,
          locale: localeEn,
          dateFormat(date) {
            const formatted =
              date.getFullYear().toString() +
              String(date.getMonth() + 1).padStart(2, "0") +
              String(date.getDate()).padStart(2, "0");
            return formatted;
          },
          range: true,
          minDate: new Date(),
          onSelect: (arg) => {
            if (arg.formattedDate) {
              let rangeDate = "";
              arg.formattedDate.forEach((d, i) => {
                if (i == 0 && inputStart) {
                  inputStart.value = d;
                } else if (i == 1 && inputStart) {
                  inputEnd.value = d;
                }

                rangeDate +=
                  (i > 0 ? " - " : "") +
                  arg.date[i].toLocaleString("en-US", { dateStyle: "short" });
              });

              if (inputStart) {
                inputStart.date = rangeDate;
                inputStart.dispatchEvent(new Event("change"));
              }
            }
          },
        });

        window.addEventListener("reset-form", () => {
          ad.clear();
        });
      });
    }
  }

  tabs() {
    const elts = document.querySelectorAll(".tabs");

    if (elts) {
      elts.forEach((el) => {
        let current = -1;
        const headers = el.querySelectorAll(".tabs-header a");
        const items = el.querySelectorAll(".tabs-item");
        const container = el.querySelector(".tabs-container");

        if (headers && items) {
          gsap.set(container, {
            height: items[0].scrollHeight,
            aspectRatio: "none",
          });

          function goto(index) {
            if (current == index) return;
            let delay = 0;
            const duration = 0.3;
            const dir = index > current ? 1 : -1;

            // HIDE OLD
            if (current >= 0) {
              items.forEach((item, i) => {
                if (i != index) {
                  gsap.to(item, {
                    autoAlpha: 0,
                    x: `${-4 * dir}rem`,
                    duration,
                    ease: "power2.inOut",
                  });
                }
              });

              headers[current].classList.remove("active");

              delay = 0.05;
            }

            // SHOW THE NEW
            gsap.fromTo(
              items[index],
              {
                autoAlpha: 0,
                x: `${4 * dir}rem`,
              },
              {
                autoAlpha: 1,
                x: "0rem",
                duration,
                delay,
                ease: "power2.inOut",
              }
            );

            gsap.to(container, {
              height: items[index].scrollHeight,
              aspectRatio: "none",
              duration,
              delay,
              ease: "power2.inOut",
            });

            headers[index].classList.add("active");

            current = index;
          }

          el.addEventListener("inview", () => {
            goto(0);
          });

          headers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();

              goto(i);
            });
          });

          // NAV
          const navs = el.querySelectorAll(".nav");
          if (navs) {
            navs.forEach((nav) => {
              nav.addEventListener("click", (e) => {
                e.preventDefault();

                let next = current >= items.length - 1 ? 0 : current + 1;

                if (nav.classList.contains("prev")) {
                  next = current <= 0 ? items.length - 1 : current - 1;
                }

                goto(next);
              });
            });
          }

          // DRAGGABLE
          const isTouch =
            "ontouchstart" in window ||
            navigator.maxTouchPoints > 0 ||
            window.matchMedia("(pointer: coarse)").matches;
          if (isTouch) {
            Draggable.create(container, {
              type: "x",

              dragResistance: 0.6, // 🔥 clé ici (0 → 1)
              edgeResistance: 0.8,

              onRelease() {
                const delta = this.endX - this.startX;
                const threshold = 40;

                gsap.to(container, {
                  x: 0,
                  duration: 0.15,
                  ease: "power3.out",
                  delay: 0.15,
                });

                if (Math.abs(delta) < threshold) return;

                if (delta < 0) {
                  const next = current >= items.length - 1 ? 0 : current + 1;
                  goto(next);
                } else {
                  const next = current <= 0 ? items.length - 1 : current - 1;
                  goto(next);
                }
              },
            });
          }
        }
      });
    }
  }

  slider() {
    const elts = document.querySelectorAll(".slider");
    if (elts) {
      elts.forEach((el) => {
        const flkty = new Flickity(el, {
          cellAlign: "left",
          contain: true,
          pageDots: true,
          prevNextButtons: false,
          autoPlay:
            el.dataset.sliderAutoplay != undefined
              ? Number.parseFloat(el.dataset.sliderAutoplay)
              : false,
          pauseAutoPlayOnHover: true,
        });
        const MAX_DELTA = 40;

        function updateSelectedIndex() {
          let closestIndex = 0;
          let minDistance = Number.POSITIVE_INFINITY;

          flkty.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.target + flkty.x);

            if (distance < minDistance) {
              minDistance = distance;
              closestIndex = index;
            }
          });
          // flkty.selectedIndex = closestIndex;
          flkty.select(closestIndex);
        }

        let timeout;

        function onScrollEnd() {
          updateSelectedIndex();
        }

        el.addEventListener(
          "wheel",
          (event) => {
            const absX = Math.abs(event.deltaX);
            const absY = Math.abs(event.deltaY);

            if (absX < absY * 1.5) return;

            event.preventDefault();

            let delta = event.deltaX;

            // ✅ limiter les gros jumps
            delta = Math.max(-MAX_DELTA, Math.min(MAX_DELTA, delta));

            // ✅ appliquer mouvement (gauche / droite OK)
            flkty.x -= delta;

            // ✅ empêcher de sortir des limites
            const minX = -flkty.slideableWidth;
            const maxX = 0;

            flkty.x = Math.max(minX, Math.min(maxX, flkty.x));

            flkty.positionSlider();

            // 🔥 IMPORTANT : synchronise l’index
            clearTimeout(timeout);
            timeout = setTimeout(onScrollEnd, 100);
          },
          { passive: false }
        );
      });
    }
  }

  pinSlider() {
    const elts = document.querySelectorAll(".pin-slider");
    if (elts && window.innerWidth > 1000) {
      elts.forEach((el) => {
        const sections = el.querySelectorAll(".content-item");
        const imgs = el.querySelectorAll(".content-imgs");
        const pagers = el.querySelectorAll(".pin-pager a");
        const total = sections.length;

        sections.forEach((section, i) => {
          if (i !== 0) {
            gsap.set(section.querySelector(".wysiwyg").children, {
              y: "2.5rem",
              autoAlpha: 0,
            });
          }
        });

        gsap.set(imgs, {
          clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
        });

        gsap.set(imgs[0], {
          clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el.querySelector(".pin"),
            start: "top top",
            end: `+=${window.innerHeight * total}`,
            scrub: true,
            pin: true,
          },
        });

        /** BUILLD TIMELINE */
        sections.forEach((section, i) => {
          if (i === sections.length - 1) return;

          const currentItems = section.querySelector(".wysiwyg").children;
          const nextItems = sections[i + 1].querySelector(".wysiwyg").children;

          /** SORTIE */
          // Cache les éléments HTML du slide précédent
          tl.to(
            currentItems,
            {
              y: "-5rem",
              duration: 0.3,
              stagger: 0.06,
              ease: "none",
            },
            i
          );
          tl.to(
            currentItems,
            {
              autoAlpha: 0,
              duration: 0.2,
              stagger: 0.06,
              ease: "none",
            },
            i
          );
          // On cache l'ancien slider
          tl.to(
            imgs[i],
            {
              clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
              ease: "none",
            },
            i
          );

          /** * ENTREE */
          // On affiche les éléments du nouveau slide
          tl.fromTo(
            nextItems,
            { y: "5rem" },
            {
              y: "0rem",
              duration: 0.3,
              stagger: 0.06,
              ease: "none",
            },
            i + 0.3
          );

          tl.fromTo(
            nextItems,
            { autoAlpha: 0 },
            {
              autoAlpha: 1,
              duration: 0.2,
              stagger: 0.06,
              onStart: () => {
                if (pagers) {
                  if (pagers[i]) pagers[i].classList.remove("active");
                  if (pagers[i + 1]) pagers[i + 1].classList.add("active");
                }
              },
              onReverseComplete: () => {
                if (pagers) {
                  if (pagers[i]) pagers[i].classList.add("active");
                  if (pagers[i + 1]) pagers[i + 1].classList.remove("active");
                }
              },
            },
            i + 0.3
          );
          // On montre le nouveau slider
          tl.to(
            imgs[i + 1],
            {
              clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
              ease: "none",
            },
            i
          ).fromTo(
            imgs[i + 1].querySelector("figure"),
            { scale: 1.2 },
            { scale: 1, ease: "none" },
            i
          );
        });

        /** BUILD NAV */
        if (pagers) {
          const trigger = tl.scrollTrigger;
          pagers.forEach((pager, i) => {
            pager.addEventListener("click", (e) => {
              e.preventDefault();

              const progress = i / (pagers.length - 1);

              const scrollPosition =
                trigger.start + progress * (trigger.end - trigger.start);

              gsap.to(window, {
                scrollTo: scrollPosition,
                duration: 1,
                ease: "power1.inOut",
              });
            });
          });
        }
      });
    }
  }

  sliderTestimonial() {
    const elts = document.querySelectorAll(".slider-testimonials");

    if (elts) {
      elts.forEach((el) => {
        const sliderContent = el.querySelector(".slider-content");
        const imgs = el.querySelectorAll(".slider-imgs figure");

        if (sliderContent) {
          let current = -1;
          const dots = el.querySelectorAll(".slider-pager a");

          const flkty = new Flickity(sliderContent, {
            pageDots: false,
            prevNextButtons: false,
            wrapAround: true,
            on: {
              select(index) {
                if (index == current) return;

                if (dots) {
                  if (dots[current]) dots[current].classList.remove("active");
                  if (dots[index]) dots[index].classList.add("active");
                }

                if (imgs) {
                  if (imgs[current] && current != index) {
                    // gsap.to(imgs[current], {
                    //   autoAlpha: 0,
                    //   ease: "expo.inOut",
                    //   y: "-10%",
                    // });
                    gsap.to(imgs[current], {
                      clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
                      duration: 0.3,
                      ease: "circ.inOut",
                    });
                  }

                  if (imgs[index]) {
                    // gsap.fromTo(
                    //   imgs[index],
                    //   {
                    //     autoAlpha: 0,
                    //     scale: 0.8,
                    //     y: "0%",
                    //   },
                    //   {
                    //     duration: 0.8,
                    //     ease: "expo.inOut",
                    //     scale: 1,
                    //     autoAlpha: 1,
                    //   }
                    // );
                    gsap.fromTo(
                      imgs[index],
                      {
                        autoAlpha: 1,
                        clipPath:
                          "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
                      },
                      {
                        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                        duration: 0.3,
                        autoAlpha: 1,
                        ease: "circ.inOut",
                      }
                    );
                  }
                }

                current = index;
              },
            },
          });

          if (dots) {
            dots.forEach((dot, i) => {
              dot.addEventListener("click", (e) => {
                e.preventDefault();
                flkty.select(i);
              });
            });
          }

          const next = el.querySelector(".slider-nav.next");
          if (next) {
            next.addEventListener("click", (e) => {
              e.preventDefault();
              flkty.next();
            });
          }
          const prev = el.querySelector(".slider-nav.prev");
          if (prev) {
            prev.addEventListener("click", (e) => {
              e.preventDefault();
              flkty.previous();
            });
          }
        }
      });
    }
  }

  carousel() {
    const carousels = document.querySelectorAll(".carousel");
    if (carousels) {
      carousels.forEach((carousel) => {
        const flkty = new Flickity(carousel, {
          cellAlign: "left",
          contain: !(carousel.dataset.carouselWraparound === "true"),
          pageDots: false,
          prevNextButtons: carousel.dataset.carouselBtns != "false",
          wrapAround: carousel.dataset.carouselWraparound === "true",
          on: {
            select(index) {
              const nbVisible = Math.round(
                carousel.offsetWidth /
                  carousel.querySelector(".item").offsetWidth
              );

              if (carousel.dataset.carouselBtns != "false") {
                if (
                  nbVisible + index >= this.slides.length &&
                  !(carousel.dataset.carouselWraparound == "true")
                ) {
                  this.nextButton.element.classList.add("disabled");
                } else {
                  this.nextButton.element.classList.remove("disabled");
                }
              }
            },
          },
        });

        const THRESHOLD = 0;
        const MAX_DELTA = 40;
        function updateSelectedIndex() {
          let closestIndex = 0;
          let minDistance = Number.POSITIVE_INFINITY;

          const { slideableWidth } = flkty;

          // 🔥 normalisation de la position (clé pour l'infini)
          const x = flkty.x % slideableWidth;

          flkty.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.target + x);

            if (distance < minDistance) {
              minDistance = distance;
              closestIndex = index;
            }
          });

          // wrap = true indispensable
          if (nbVisible <= 1) {
            // flkty.select(
            //   Math.round(flkty.x / flkty.slidesWidth) % flkty.slides.length,
            //   false,
            //   false
            // );
          } else {
            flkty.selectedIndex = closestIndex;
          }
        }

        let timeout;

        function onScrollEnd() {
          updateSelectedIndex();
        }
        const nbVisible = Math.round(
          carousel.offsetWidth / carousel.querySelector(".item").offsetWidth
        );
        if (nbVisible > 1) {
          carousel.addEventListener(
            "wheel",
            (event) => {
              const absX = Math.abs(event.deltaX);
              const absY = Math.abs(event.deltaY);

              if (absX < absY * 1.5) return;
              event.preventDefault();

              let delta = event.deltaX;

              // ✅ limiter les gros jumps
              delta = Math.max(-MAX_DELTA, Math.min(MAX_DELTA, delta));

              // ✅ appliquer mouvement (gauche / droite OK)
              flkty.x -= delta;

              // ✅ empêcher de sortir des limites
              const minX = -flkty.slideableWidth;
              const maxX = 0;
              flkty.x -= delta;

              flkty.positionSlider();

              // 🔥 IMPORTANT : synchronise l’index
              clearTimeout(timeout);
              timeout = setTimeout(onScrollEnd, 400);
              // updateSelectedIndex();
            },
            { passive: false }
          );
        }
      });
    }
  }

  accordion() {
    const elts = document.querySelectorAll(".accordion");

    if (elts) {
      elts.forEach((el) => {
        const items = document.querySelectorAll(".accordion-item");
        const headers = document.querySelectorAll(".accordion-header");
        const contents = document.querySelectorAll(".accordion-content");

        if (items && headers && contents) {
          headers.forEach((header, i) => {
            header.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();

              items[i].classList.toggle("open");

              gsap.to(contents[i], {
                height: items[i].classList.contains("open")
                  ? contents[i].scrollHeight
                  : 0,
                autoAlpha: items[i].classList.contains("open") ? 1 : 0,
                duration: 0.3,
                ease: "circ.inOut",
              });

              items.forEach((item, j) => {
                if (i != j) {
                  gsap.to(contents[j], {
                    autoAlpha: 0,
                    height: 0,
                    duration: 0.3,
                    ease: "circ.inOut",
                  });
                  item.classList.remove("open");
                }
              });
            });
          });

          window.addEventListener("accordion-close-all", () => {
            items.forEach((item, i) => {
              gsap.to(contents[i], {
                autoAlpha: 0,
                height: 0,
                duration: 0.3,
                ease: "circ.inOut",
              });
              item.classList.remove("open");
            });
          });
        }
      });
    }
  }

  liveSearch() {
    const elts = document.querySelectorAll('.block-search  input[name="s"]');

    if (elts) {
      elts.forEach((input) => {
        let timeout = null;

        input.addEventListener("input", function () {
          clearTimeout(timeout);

          const query = this.value;

          if (query.length < 3) return;

          timeout = setTimeout(() => {
            fetch(`/wp-admin/admin-ajax.php?action=live_search&term=${query}`)
              .then((res) => res.json())
              .then((data) => {
                const results = input
                  .closest(".block-search")
                  .querySelector(".results");
                results.innerHTML = "";

                data.forEach((item) => {
                  results.innerHTML += `<li class="my-4 mr-4 last:mr-0"><a href="${item.link}" class="btn -border"><span><span data-title="${item.title}">${item.title}</span></span></a></li>`;
                });
              });
          }, 300); // debounce
        });
      });
    }
  }

  filters() {
    const forms = document.querySelectorAll(".js-filters");
    const _ = this;

    if (forms) {
      forms.forEach((form) => {
        const inputs = form.querySelectorAll("input:not(.no-update)");
        const triggerFilters = form.querySelector(".filters-trigger");

        /** * ON OUVRE LES FILTRES & RECHERCHE */
        if (triggerFilters) {
          const submit = triggerFilters.querySelector('button[type="submit"]');
          const input = triggerFilters.querySelector("input");
          const triggers = form.querySelectorAll(".trigger-open");

          /** ON OUVRE LA BOX DES FILTRES */
          if (triggers) {
            triggers.forEach((trigger) => {
              trigger.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                triggerFilters.classList.remove("is-search");
                HTML.classList.toggle("open-filters");
              });

              // ON AJOUTE UNE PASTILLE SUR LE TRIGGER
              // POUR INFORMER QUE DES FILTRES ONT ÉTÉ SÉLECTIONNÉS
              HTML.addEventListener("update-trigger", () => {
                if (form.querySelectorAll(".badge").length > 0) {
                  triggerFilters.classList.add("has-filters-selected");
                } else {
                  triggerFilters.classList.remove("has-filters-selected");
                }
              });
            });
          }

          /** ON FERME LE CHAMPS DE RECHERCHE SI ON CLIQUE AILLEUR */
          document.body.addEventListener("click", (e) => {
            if (
              !e.target.classList.contains("filters-trigger") &&
              !e.target.closest(".filters-trigger") &&
              !e.target.classList.contains("filters") &&
              !e.target.closest(".filters")
            ) {
              triggerFilters.classList.remove("is-search");
              HTML.classList.remove("open-filters");
            }
          });

          /** ON OUVRE LE CHAMPS DE RECHERCHE */
          if (submit) {
            submit.addEventListener("click", (e) => {
              if (!triggerFilters.classList.contains("is-search")) {
                e.preventDefault();
                e.stopPropagation();
                triggerFilters.classList.add("is-search");
                input.focus();
              }
            });

            // ON AFFICHE UNE PASTILLE OU NON SUR LE BOUTON SI L'ON A MIS DES KEYWORDS
            const inputSearch = form.querySelector('input[name="keyword"]');
            if (inputSearch) {
              inputSearch.addEventListener("keydown", () => {
                if (inputSearch.value.length > 0) {
                  triggerFilters.classList.add("has-keywords");
                } else {
                  triggerFilters.classList.remove("has-keywords");
                }
              });
            }
          }
        }

        //* * ON AFFICHE UN PASTILLE POUR INDIQUER LE NOMBRE DE FILTRE SELECTIONNÉ  */
        if (inputs) {
          inputs.forEach((input) => {
            const label = input.closest(".filter-item").querySelector(".label");

            // INPUT CHECKBOX
            if (input.type == "checkbox") {
              input.addEventListener("change", () => {
                const checkedValues = Array.from(
                  document.querySelectorAll(
                    `input[name="${input.name}"]:checked`
                  )
                ).map((cb) => cb.value);

                if (label) {
                  const badge = label.querySelector(".badge");
                  if (badge) badge.remove();

                  if (checkedValues.length > 0) {
                    const badge = document.createElement("div");
                    badge.classList.add("badge");
                    badge.innerHTML = checkedValues.length;
                    label.append(badge);
                  }
                }

                HTML.dispatchEvent(new Event("update-trigger"));
              });
            }
            // INPUT DATE
            else if (input.name == "date_from") {
              input.addEventListener("change", () => {
                if (label) {
                  const oldBadge = label.querySelector(".badge");
                  if (oldBadge) oldBadge.remove();

                  if (input.date != "") {
                    const badge = document.createElement("div");
                    badge.classList.add("badge");
                    badge.innerHTML = input.date;

                    label.append(badge);
                  }
                }

                HTML.dispatchEvent(new Event("update-trigger"));
              });
            }
          });
        }

        //* * SUBMISSION FORM */
        form.addEventListener("submit", function (e) {
          e.preventDefault();
          HTML.classList.add("is-loading");
          HTML.classList.remove("open-filters");

          if (triggerFilters) triggerFilters.classList.remove("is-search");

          const container = document.querySelector(form.dataset.container);

          /**
           * Fonction envoyant une requete ajax pour filtrer/trier les événements
           * @param {Float} lat
           * @param {Float} lng
           */
          function fetchEvents(lat = null, lng = null) {
            const formData = new FormData(form);
            formData.append("action", "filter_events");

            if (lat && lng) {
              formData.append("lat", lat);
              formData.append("lng", lng);
            }

            fetch(ajax_params.ajax_url, {
              method: "POST",
              body: formData,
            })
              .then((response) => response.text())
              .then((data) => {
                HTML.classList.remove("is-loading");
                window.dispatchEvent(new Event("accordion-close-all"));

                if (container) {
                  container.innerHTML = data;

                  HTML.dispatchEvent(new Event("resize"));

                  _.lazyload.update();
                  _.inViewport();
                  // gsap.to(window, {
                  //   scrollTo: {
                  //     y: container,
                  //     offsetY:
                  //       document.querySelector(".main-header").offsetHeight + 40,
                  //   },
                  //   duration: 0.5,
                  //   ease: "power2.inOut",
                  // });
                }
              })
              .catch((error) => {
                HTML.classList.remove("is-loading");
                window.dispatchEvent(new Event("accordion-close-all"));
                console.error("Error:", error);
              });
          }

          // Si on coche le trie par "events near me"
          // on demande la géolocalisation
          // sinon on envoie la requete
          const sort = form.querySelector('input[name="sort"]:checked');
          if (sort && sort.value === "near") {
            if (!navigator.geolocation) {
              alert("Geolocation not supported");
              return;
            }

            navigator.geolocation.getCurrentPosition(
              (position) => {
                fetchEvents(
                  position.coords.latitude,
                  position.coords.longitude
                );
              },
              () => {
                alert("Location permission denied");
              }
            );
          } else {
            fetchEvents();
          }

          return false;
        });

        form.addEventListener("reset", () => {
          window.dispatchEvent(new Event("reset-form"));
          window.dispatchEvent(new Event("accordion-close-all"));
          const badges = form.querySelectorAll(".badge");
          if (badges) badges.forEach((badge) => badge.remove());

          if (triggerFilters) {
            triggerFilters.classList.remove(
              "has-filters-selected",
              "has-keywords"
            );
          }

          setTimeout(() => {
            form.dispatchEvent(new Event("submit"));
          }, 100);
        });
      });
    }
  }

  sticky() {
    const elts = document.querySelectorAll("[data-sticky]");

    if (elts) {
      elts.forEach((el) => {
        const container =
          el.dataset.stickyContainer != undefined
            ? document.querySelector(el.dataset.stickyContainer)
            : el.parentElement;
        const offsetBottom =
          el.dataset.stickyOffsetBottom != undefined
            ? el.dataset.stickyOffsetBottom
            : 0;
        const stopOffset =
          el.dataset.stickyStopOffset != undefined
            ? el.dataset.stickyStopOffset
            : 0;
        const mode =
          el.dataset.stickyMode != undefined
            ? el.dataset.stickyMode
            : "absolute"; // bottom or absolute

        let placeholder = null;

        /** CREATE PLACEHOLDE */
        placeholder = document.createElement("div");
        // placeholder.style.width = `${el.offsetWidth}px`;
        placeholder.style.height = `${el.offsetHeight}px`;
        placeholder.style.display = "block";
        el.parentNode.insertBefore(placeholder, el);

        const rect = placeholder.getBoundingClientRect();
        el.style.top = `${
          rect.top - placeholder.parentElement.getBoundingClientRect().top
        }px`;

        window.addEventListener("scroll", () => update());
        window.addEventListener("resize", () => update());

        setTimeout(() => {
          window.dispatchEvent(new Event("resize"));
        }, 100);

        // update();

        function update() {
          const rect = placeholder.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          const viewportHeight = window.innerHeight;

          const triggerPoint = viewportHeight - offsetBottom;

          el.classList.add("is-ready");

          // 🔹 Gestion fin container
          const containerBottomLimit =
            containerRect.bottom - stopOffset * window.innerHeight;

          // 🔹 Activer sticky quand le bottom atteint le viewport
          if (rect.bottom <= triggerPoint) {
            if (containerBottomLimit <= viewportHeight - offsetBottom) {
              if (mode === "absolute") {
                // TO ABSOLUTE
                el.classList.remove("sticky-active");
                el.classList.add("sticky-absolute");

                el.style.bottom = "0";
              } else if (mode === "fade") {
                // TO FADE
                el.classList.add("sticky-fade");
              }
            } else {
              el.classList.add("sticky-active");
              el.classList.remove("sticky-absolute", "sticky-fade");
              el.style.bottom = `${offsetBottom}px`;
              el.style.top = `auto`;
            }
          } else {
            // DEACTIVATATE STICKY
            el.classList.remove("sticky-active");
            el.classList.remove("sticky-absolute");
            el.style.bottom = `auto`;
            el.style.top = `${
              rect.top - placeholder.parentElement.getBoundingClientRect().top
            }px`;
          }
        }
      });
    }
  }

  clamp() {
    const elts = document.querySelectorAll(".line-clamp-6");

    if (elts) {
      elts.forEach((el) => {
        const trigger = el.nextElementSibling;
        const heightClamp = el.clientHeight;
        const isClamped = el.scrollHeight > el.clientHeight;

        if (trigger && isClamped) {
          trigger.classList.remove("hidden");
          gsap.set(el, { height: heightClamp });

          const link = trigger.querySelector("a");
          link.addEventListener("click", (e) => {
            e.preventDefault();
            if (!el.classList.contains("is-open")) {
              gsap.to(el, {
                height: el.scrollHeight,
                duration: 0.3,
                webkitLineClamp: "unset",
                ease: "power2.inOut",
              });
            } else {
              gsap.to(el, {
                height: heightClamp,
                duration: 0.3,
                ease: "power2.inOut",
                onComplete: () => gsap.set(el, { webkitLineClamp: 6 }),
              });
            }
            el.classList.toggle("is-open");
            trigger.classList.toggle("is-open");
          });
        }
      });
    }
  }

  aside() {
    const triggers = document.querySelectorAll("[data-aside]");
    if (triggers) {
      triggers.forEach((trigger) => {
        const aside = document.querySelector(trigger.dataset.aside);
        if (aside) {
          trigger.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            aside.classList.toggle("is-open");
          });

          const closeBtn = aside.querySelector(".aside-close");
          if (closeBtn) {
            closeBtn.addEventListener("click", (e) => {
              e.preventDefault();
              aside.classList.remove("is-open");
            });
          }

          document.body.addEventListener("click", (e) => {
            if (
              aside.classList.contains("is-open") &&
              !e.target.classList.contains(
                trigger.dataset.aside.replace(".", "")
              ) &&
              !e.target.closest(trigger.dataset.aside)
            ) {
              aside.classList.remove("is-open");
            }
          });
        } else {
          console.warn(
            `No aside found for trigger with selector ${trigger.dataset.aside}`
          );
        }
      });
    }
  }

  ticketsProtected() {
    const forms = document.querySelectorAll(".event-form-protected");
    if (forms) {
      forms.forEach((form) => {
        const containerTicket = form.closest(".aside-tickets");
        const contentTicket = form.closest(".content");

        form.addEventListener("submit", function (e) {
          e.preventDefault();

          containerTicket.classList.add("is-loading");
          const msgs = containerTicket.querySelectorAll(".error-message");
          if (msgs && msgs.length > 0) msgs.forEach((m) => m.remove());

          const form = e.target;
          const data = new FormData(form);
          data.append("action", "check_protected_password");
          data.append("post_id", form.dataset.post);

          fetch("/wp-admin/admin-ajax.php", {
            method: "POST",
            credentials: "same-origin",
            body: data,
          })
            .then((res) => res.json())
            .then(async (res) => {
              if (res.success) {
                // On charge le contenu qui n'est plus connecté.
                fetch(window.location.href)
                  .then((res) => res.text())
                  .then((html) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");

                    const newContent = doc.querySelector(
                      ".aside-tickets .content"
                    );
                    if (newContent) {
                      contentTicket.replaceWith(newContent);
                    }

                    containerTicket.classList.remove("is-loading");
                  });
              } else {
                const msg = document.createElement("div");
                msg.classList.add("error-message");
                msg.innerText = res.data;
                form.append(msg);

                containerTicket.classList.remove("is-loading");
              }
            });
          return false;
        });
      });
    }
  }

  async map() {
    const maps = document.querySelectorAll(".js-map");
    if (maps) {
      maps.forEach(async (el) => {
        async function initMap() {
          setOptions({
            key: "AIzaSyAQehCDFjopICqgqyRIKcYwEEJbfgCkhhE",
            v: "weekly",
          });

          const { Map } = await importLibrary("maps");
          const { AdvancedMarkerElement } = await importLibrary("marker");

          const { lat, lng } = el.dataset;
          const zoom = el.dataset.zoom || 14;

          const map = new Map(el, {
            center: {
              lat: Number.parseFloat(lat),
              lng: Number.parseFloat(lng),
            },
            zoom,
            mapId: "d086f720d9ced5c32debc813",
            cameraControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
          });

          const markerImage = document.createElement("img");
          markerImage.src = `${WP_THEME}/static/svg/marker.svg`;
          markerImage.width = 24;
          markerImage.height = 44;

          new AdvancedMarkerElement({
            map,
            position: {
              lat: Number.parseFloat(lat),
              lng: Number.parseFloat(lng),
            },
            content: markerImage,
          });
        }

        const container = el.closest(".js-map-container");
        if (container) {
          const trigger = container.querySelector(".js-map-trigger");
          if (trigger) {
            trigger.addEventListener("click", async (e) => {
              e.preventDefault();

              await initMap();
              gsap.to(el, {
                autoAlpha: 1,
              });
            });
          }
        } else {
          initMap();
        }
      });
    }
  }

  marqueeCarousel() {
    const elts = document.querySelectorAll(".marquee-carousel");

    if (elts) {
      elts.forEach((el) => {
        const flkty = new Flickity(el, {
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          draggable: true,
          cellAlign: "center",
        });

        let lastScrollY = window.scrollY;
        let timer = 0;
        const coeff = 0.3;
        const speed = -1; // direction par défaut

        // Détection du scroll
        window.addEventListener("scroll", function () {
          // if (window.scrollY > lastScrollY) {
          //   speed = -1; // scroll vers le bas → gauche
          // } else {
          //   speed = 1; // scroll vers le haut → droite
          // }
          lastScrollY = window.scrollY;
        });

        el.addEventListener("mouseenter", () => {
          cancelAnimationFrame(timer);
        });
        el.addEventListener("mouseleave", () => {
          animate();
        });

        // Animation continue
        function animate() {
          flkty.x += speed * coeff;
          flkty.positionSlider();
          timer = requestAnimationFrame(animate);
        }

        animate();
      });
    }
  }

  marquee() {
    const elts = document.querySelectorAll(".marquee .line");
    if (elts) {
      elts.forEach((track) => {
        track.innerHTML += track.innerHTML;

        this.lazyload.update();

        const direction = -1; // 1 = vers la gauche, -1 = vers la droite
        const speed = 40; // pixels par seconde
        let x = 0; // position actuelle
        let wrapWidth; // largeur d’un bloc A
        let lastScrollY = window.scrollY;
        const timer = 0;

        function computeWrapWidth() {
          // On divise par 2 car on a mis A + A
          wrapWidth = track.scrollWidth / 2;
        }

        // 2) Calcul initial + recalcul au resize
        window.addEventListener("load", computeWrapWidth);
        window.addEventListener("resize", computeWrapWidth);

        // 3) Détection du sens de scroll
        window.addEventListener(
          "scroll",
          () => {
            const currentScrollY = window.scrollY;

            // if (currentScrollY > lastScrollY) {
            //   // Scroll vers le bas → texte va vers la gauche
            //   direction = 1;
            // } else if (currentScrollY < lastScrollY) {
            //   // Scroll vers le haut → texte va vers la droite
            //   direction = -1;
            // }

            lastScrollY = currentScrollY;
          },
          { passive: true }
        );
        track.addEventListener("mouseenter", () => {
          gsap.ticker.remove(animate);
        });
        track.addEventListener("mouseleave", () => {
          lastTime = performance.now();
          gsap.ticker.add(animate);
        });

        // 4) Animation avec GSAP.ticker (boucle infinie)
        let lastTime = performance.now();

        function animate() {
          const now = performance.now();
          const dt = (now - lastTime) / 1000; // secondes écoulées
          lastTime = now;

          if (!wrapWidth) return; // au cas où le layout n’est pas encore prêt

          // Mise à jour de la position en fonction du temps, de la vitesse et du sens
          x += direction * speed * dt;

          // 5) Normalisation dans l’intervalle [-wrapWidth, 0]
          //    pour boucler proprement dans les deux sens.
          if (x <= -wrapWidth) {
            x += wrapWidth;
          } else if (x >= 0) {
            x -= wrapWidth;
          }

          gsap.set(track, { x }); // applique transform: translateX(x)
        }

        gsap.ticker.add(animate);
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
